import * as React from "react";
import { cn } from "@/lib/cn";

/**
 * Card — Volume 03 §10. Ưu tiên border + surface trước shadow (Volume 02 §9).
 * `interactive` cho card có hover/click toàn khối.
 * `selected` dùng border primary + nền subtle (Volume 02 §8).
 */
export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  interactive?: boolean;
  selected?: boolean;
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ className, interactive, selected, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "rounded-lg border bg-surface p-4 sm:p-6",
        interactive &&
          "cursor-pointer transition-shadow duration-fast ease-out hover:shadow-sm focus-visible:outline-none focus-visible:ring focus-visible:ring-ring",
        selected ? "border-primary bg-blue-50 dark:bg-primary/10" : "border-border",
        className
      )}
      {...props}
    />
  )
);
Card.displayName = "Card";

export function CardHeader({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("mb-4 flex flex-col gap-1", className)} {...props} />;
}

export function CardTitle({ className, ...props }: React.HTMLAttributes<HTMLHeadingElement>) {
  return <h3 className={cn("text-h5 text-foreground", className)} {...props} />;
}

export function CardDescription({
  className,
  ...props
}: React.HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn("text-body-sm text-muted", className)} {...props} />;
}

export function CardContent({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("text-body text-foreground-secondary", className)} {...props} />;
}

export function CardFooter({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("mt-4 flex items-center gap-3", className)} {...props} />;
}
